import React from "react";
import ImageBackground from "../components/ImageBackground";
import VerticalSeparator from "../components/VerticalSeparator";
import aficheCertificado from "../images/CertificadoDircetur.jpg"; // Imagen para el enlace
import cityImg from "../images/images-paquetes/encanto-amazonico/20160710_131742.jpg";

const CertificadoDircetur = () => {
  // Ruta relativa al archivo PDF en la carpeta public
  const pdfUrl = "/CertificadoDircetur.pdf";

  return (
    <div>
      <ImageBackground url={cityImg} />
      <VerticalSeparator altura="5" />
      <div
        className="poster-container"
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <h1 style={{ padding: "10px", alignSelf: "center" }}>
          Certificado DIRCETUR
        </h1>
        <a href={pdfUrl} target="_blank" rel="noopener noreferrer">
          <img
            src={aficheCertificado}
            alt="Afiche de Certificado DIRCETUR"
            className="poster-image"
            style={{
              width: "100%",
              height: "auto",
              cursor: "pointer",
              marginBottom: "5rem",
            }}
          />
        </a>
      </div>
    </div>
  );
};

export default CertificadoDircetur;
